
import { supabase } from "@/integrations/supabase/client";
import { AiRequestParams, AiResponse } from "./types";

// Core AI service for basic content generation functionality
export const coreAiService = {
  async generateContent(params: AiRequestParams): Promise<AiResponse> {
    try {
      console.log("Calling OpenAI service with params:", {
        action: params.model,
        temperature: params.temperature,
        maxTokens: params.maxTokens,
        promptLength: params.prompt?.length || 0
      });
      
      // Use Supabase Edge Function to securely call OpenAI API
      const { data, error } = await supabase.functions.invoke('openai-proxy', {
        body: {
          action: 'generate',
          params
        }
      });

      if (error) {
        console.error('OpenAI proxy error:', error);
        throw new Error(error.message);
      }
      
      if (!data) {
        console.error('No data returned from OpenAI proxy');
        throw new Error('No data returned from OpenAI proxy');
      }

      console.log("OpenAI response received:", data);
      
      return {
        success: true,
        data
      };
    } catch (error: any) {
      console.error('AI content generation error:', error);
      return {
        success: false,
        error: error.message || 'Failed to generate AI content'
      };
    }
  },

  async chatWithAI(prompt: string, verbosityLevel?: 'concise' | 'balanced' | 'detailed'): Promise<AiResponse> {
    try {
      console.log("Calling chatWithAI, prompt length:", prompt?.length || 0);
      
      // Use Supabase Edge Function to securely call OpenAI API
      const { data, error } = await supabase.functions.invoke('openai-proxy', {
        body: {
          action: 'chat',
          params: {
            prompt,
            systemPrompt: 'You are a helpful AI assistant for a news publishing platform. Provide accurate information and cite sources where possible.',
            temperature: 0.7,
            maxTokens: 1000,
            model: 'gpt-4o-mini',
            verbosityLevel
          }
        }
      });

      if (error) throw new Error(error.message);
      
      return {
        success: true,
        data
      };
    } catch (error: any) {
      console.error('AI chat error:', error);
      return {
        success: false,
        error: error.message || 'Failed to communicate with AI assistant'
      };
    }
  }
};
